import apiService from './api'

/**
 * Cases API Service
 * Handles all case-related API endpoints
 */

export const casesApi = {
  /**
   * Get all available cases
   * Returns: { cases: [...], me: {...}, alert?: string, error?: string }
   */
  async getCases() {
    try {
      const response = await apiService.get('/api/cases/')
      return response
    } catch (error) {
      console.error('Failed to fetch cases:', error)
      throw error
    }
  },

  /**
   * Get detailed information about a specific case
   * @param {number} caseId - The ID of the case
   * Returns: { case: {...}, me: {...}, alert?: string, error?: string }
   */
  async getCaseDetails(caseId) {
    try {
      const response = await apiService.get(`/api/case/${caseId}/`)
      return response
    } catch (error) {
      console.error(`Failed to fetch case ${caseId} details:`, error)
      throw error
    }
  },

  /**
   * Open a case
   * @param {string} caseId - The ID of the case to open
   * Returns: { open: {...}, me: {...}, alert?: string, error?: string }
   */
  async openCase(caseId) {
    try {
      const response = await apiService.post(`/api/case/${caseId}/open/`)
      return response
    } catch (error) {
      console.error(`Failed to open case ${caseId}:`, error)
      throw error
    }
  },

  /**
   * Открыть кейс несколько раз (множественное открытие)
   * @param {string} caseId - ID кейса для открытия
   * @param {number} count - Количество открытий (2-10)
   * Returns: { open: [{...}, {...}, ...], me: {...}, alert?: string, error?: string }
   */
  async openCaseMultiple(caseId, count) {
    try {
      const response = await apiService.post(`/api/case/${caseId}/open/${count}/`)
      return response
    } catch (error) {
      console.error(`Failed to open case ${caseId} ${count} times:`, error)
      throw error
    }
  }

}

export default casesApi
